export const getHttpStatusFromBridgeError = (error: unknown): number | undefined => {
  if (typeof error !== 'string') {
    return undefined
  }

  try {
    const parsed = JSON.parse(error) as { httpStatus?: number }
    return parsed.httpStatus
  } catch {
    return undefined
  }
}

export const isW8DocumentUnavailable = (error: unknown): boolean =>
  getHttpStatusFromBridgeError(error) === 422
